// removed by extract-text-webpack-plugin
module.exports = {"rule":"rule","description":"description","value":"value","menu-bar":"menu-bar","menu":"menu","menu-item":"menu-item","paren":"paren"};


//////////////////
// WEBPACK FOOTER
// ./client/styling/bnf-staile.css
// module id = 164
// module chunks = 0